import type {Root} from "react-dom/client";
import {createRoot} from "react-dom/client";
import Changelog from "../../../hilfe/changelog.mdx";
import * as markdownStyles from "./react/Standard/StaticMarkdownRenderer/StaticMarkdownRenderer.module.scss";

const appNode = document.createElement("div");
document.body.append(appNode);
const root: Root = createRoot(appNode);

root.render(
    <div className={markdownStyles.container}>
        <Changelog />
    </div>
);
